import get from "lodash/get";
import React from "react";

import Stack from "veneer/Stack";

import { useAppSelector } from "cortex/ui/src/hooks";

import { WsExceptionStatus } from "./WsExceptionStatus";
import { WsOnlineStatus } from "./WsOnlineStatus";

function WsConnStatus() {
  const connection = useAppSelector((state) =>
    get(state, "global.connection", null),
  ) as {
    wsException?: string | number;
    wsOnline?: boolean;
  } | null;
  const wsException = connection?.wsException;
  const wsOnline = Boolean(connection?.wsOnline);

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      <WsOnlineStatus online={wsOnline} />
      <WsExceptionStatus exception={wsException} />
    </Stack>
  );
}

export { WsConnStatus };
export default WsConnStatus;
